import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { GlobalVariables } from '../../constants/global-constants';
import { CustomTitleCasePipe } from '../../pipes/custom-title-case/custom-title-case-pipe.pipe';
@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [RouterModule, CommonModule, TitleCasePipe, MatIconModule,CustomTitleCasePipe],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent {

  routeList: any[] = [];
  routeConfig: any[];
  routeArray: any[];
  currentRoute = "";
  parent = "";
  languageCodeList = ['en-us', 'pt-br','pl-pl','es-es']

  tables = ['client', 'data-sources', 'data-internal-use', 'product-purchased', 'chargebacks', 'merchant', 'merchant-services', 'requests', 'descriptors', 'billing-client-service'];
  isTable = false;
  hasId = false

  ngOnInit() {
  }

  constructor(private router: Router) {
    this.routeConfig = this.router.config;
    this.router.events.forEach(x => {
      if (x instanceof NavigationEnd) {
        this.generateURLList(x.url);
      }
    })

    if (this.routeList.length == 0) {
      this.generateURLList(this.router.url);

    }
  }

  generateURLList(url: string) {
    this.currentRoute = url;
  
    const [pathPart, queryPart] = url.split('?');
    const queryParams = new URLSearchParams(queryPart || '');
    const queryKeys = Array.from(queryParams.keys());

    this.hasId = queryKeys.includes('id') || queryKeys.includes('userId');
  
    const pathSegments = pathPart.split('/').filter(Boolean);
  
    let prevRoute = '';
    this.routeList = [];
  
    for (let i = 0; i < pathSegments.length; i++) {
      const segment = pathSegments[i];
  
      prevRoute += '/' + segment;
  
      if (segment === 'client' && Number(pathSegments[i + 1])) {
        prevRoute += '/' + pathSegments[i + 1]; 
        i++; 
        continue;
      }
  
      if (segment.toLowerCase() === 'edit' && this.hasId) {
        continue;
      }
  
      this.routeList.push({
        url: prevRoute,
        name: this.localizeName(segment.replace(/-/g, ' '))
      });
    }
  
    if (queryParams.has('userId')) {
      const userId = queryParams.get('userId');
      this.routeList.push({
        url: this.currentRoute,
        name: userId
      });
    } else if (queryParams.has('id')) {
      const id = queryParams.get('id');
      this.routeList.push({
        url: this.currentRoute,
        name: id
      });
    }
    this.isTable = this.routeList.some(x => this.tables.includes(x.name));
  }
  
  getRouteLink(fullUrl: string): { path: string[] | string, queryParams: any } {
    const [path, query] = fullUrl.split('?');
    const queryParams = {};
    if (query) {
      const pairs = new URLSearchParams(query);
      for (const [key, value] of pairs.entries()) {
        queryParams[key] = value;
      }
    }
    return {
      path,
      queryParams: queryParams
    };
  }
  

  localizeName(name: string) {
    var localName = GlobalVariables.urlSegmentList_to_localize[name];
    if (localName) {
      return localName;
    }
    return name;
  }
}
